class Popup {
    constructor(overlaySelector = "", popupSelector = "") {
        this.classesToBind = ["confirm-popup"];
        this.deleteLink = "#";

        this.page = document.querySelector("html");

        this.overlay = document.querySelector(overlaySelector || "[id$=popup-overlay]");
        this.popup = document.querySelector(popupSelector || "[id$=popup]");

        this.popupMessage = document.getElementById("popup-message");

        if (this.overlay && this.popup) {
            this.validate = this.validate.bind(this);
            this.cancel = this.cancel.bind(this);

            this.validateButton = this.popup.querySelector("#popup-validate");
            if (this.validateButton) {
                this.validateButton.addEventListener("click", this.validate);
            }

            this.popupDefaultContent = this.popup.innerHTML;
            this.bindCancelButton();

            if (overlaySelector === "" && popupSelector === "") {
                this.classesToBind.forEach(classToBind => this.addEvent(classToBind));
            }

            document.addEventListener("bindCancelButton", () => this.bindCancelButton());
        }
    }

    bindCancelButton(selector = "") {
        const cancelButton = this.popup.querySelector(`${selector} .popup-cancel`);
        if (cancelButton && !(cancelButton.onclick)) {
            cancelButton.addEventListener("click", this.cancel);
        }
    }

    addEvent(classToBind) {
        Array.from(document.getElementsByClassName(classToBind)).forEach((element) => {
            element.addEventListener("click", (event) => {
                event.preventDefault();
                this.deleteLink = event.target.href;
                if (event.target.dataset.confirmationMessage) {
                    document.getElementById("popup-message").innerHTML = event.target.dataset.confirmationMessage;

                    // Quick fix, need better way.
                    this.validateButton = document.querySelector("#popup-validate");
                    if (this.validateButton) {
                        this.validateButton.addEventListener("click", this.validate);
                    }
                }
                this.toggleClasses(event.target);
            });
        });
    }

    validate() {
        window.location.href = this.deleteLink;
    }

    cancel() {
        this.toggleClasses();

        if (this.popupDefaultContent && this.popup.innerHTML !== this.popupDefaultContent) {
            this.popup.innerHTML = this.popupDefaultContent;
            this.bindCancelButton();
        }
    }

    toggleClasses() {
        this.page.classList.toggle("o-h");

        this.overlay.classList.toggle("d-n");
        this.overlay.classList.toggle("d-f");

        this.popup.classList.toggle("d-n");
        this.popup.classList.toggle("d-f");
    }
}

export default Popup;
